import { createComponentProgrammatic } from '@/helpers/createComponentProgrammatic'


export const createBTextFieldAteModal = (parent, propsData) => {
  const AsyncComponent = import(
    /* webpackChunkName: "BTextFieldAteModal" */
    './BTextFieldAteModal.vue'
  )

  const result = createComponentProgrammatic(
    AsyncComponent,
    parent,
    propsData,
  )

  return result
}
